import React, { useState, useEffect } from "react"

import { Link } from "gatsby"
import ReactTooltip from "react-tooltip"
import { Popover, Transition } from "@headlessui/react"

import Image from "../common/image"
import TopicCard from "./topiccard"
import TopicList from "./topiclist"

// lists a bunch of topics
const TopicPlatformIcons = ({
  platforms,
  topic,
  currentPlatform,
  totalCount,
}) => {
  const [showCount, setShowCount] = useState(8)

  useEffect(() => {
    if (typeof window !== "undefined" && window.screen.width < 600) {
      setShowCount(6)
    }
  }, [])

  const platformsToShow = platforms
    .filter(p => !p.removed)
    // .filter(p => p.slug !== 'independent')
    .filter(p => p.count >= 1)
    .sort((a, b) => (a.count < b.count ? 1 : b.count < a.count ? -1 : 0))
    .filter((t, i) => i < showCount)
  // console.log(platformsToShow)

  const platformsNotShown = platforms.filter(
    p => p.count && !platformsToShow.includes(p)
  )

  // return ''

  return (
    <section aria-labelledby="platform-topics">
      <div className="">
        {/*<div className="relative">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-gray-200" />
          </div>
          <div className="relative flex items-center justify-between">
            <h2 className="pr-3 bg-white text-xl font-medium text-gray-900">
              Platforms
            </h2>
          </div>
        </div>*/}
        <div className={`mt-2`}>
          <ReactTooltip
            id={`platforms-tooltip`}
            place="top"
            effect="solid"
            backgroundColor="black"
            textColor="white"
            className=""
          />
          <div className="flex flex-wrap">
            {platformsToShow.map(p => (
              <Link
                to={`/topics/${topic.slug}/platform/${p.slug}/`}
                key={p.slug}
                className={`p-1 border-2 ${
                  currentPlatform && currentPlatform.slug === p.slug
                    ? "border-rose-500"
                    : "border-gray-100 hover:border-gray-200"
                }  bg-white rounded-full relative cursor-pointer mr-3 mb-2`}
                data-for={`platforms-tooltip`}
                data-tip={p.name}
              >
                <div className="bg-white h-6 w-6 rounded-full overflow-hidden">
                  {p.slug !== "independent" ? (
                    <img
                      src={p.logoSmall}
                      alt={p.name}
                      className="h-full w-full h-8 w-8 object-contain"
                    />
                  ) : (
                    <Image
                      className="h-full w-full h-6 w-6 object-contain p-3"
                      fileName="icon.png"
                      alt="Hive Index Logo"
                      // width="36"
                      // height="36"
                      objectFit="contain"
                      // loading="lazy"
                    />
                  )}
                </div>

                <div className="h-5 w-5 p-0.5 absolute -right-2 -bottom-2 rounded-full text-center bg-gray-100 text-xs font-semibold text-gray-500">
                  <div>{p.count}</div>
                </div>
              </Link>
            ))}

            {currentPlatform ? (
              <Link
                to={`/topics/${topic.slug}/`}
                className="p-1 border-2 border-gray-100 hover:border-gray-200 bg-white rounded-full relative cursor-pointer mr-3 mb-2"
                data-for={`platforms-tooltip`}
                data-tip="All Platforms"
              >
                <div className="bg-white h-6 w-6 rounded-full overflow-hidden flex items-center justify-center">
                  <span className="text-[10px] font-semibold text-gray-600">
                    All
                  </span>
                </div>
                <div className="h-5 w-5 p-0.5 absolute -right-2 -bottom-2 rounded-full text-center bg-gray-100 text-xs font-semibold text-gray-500">
                  <div>{totalCount}</div>
                </div>
              </Link>
            ) : (
              ""
            )}

            {platformsNotShown.length ? (
              <Popover className="relative">
                {({ open }) => (
                  <>
                    <Popover.Button
                      aria-label="More"
                      className={`${
                        open ? "text-gray-900" : "text-gray-500"
                      } p-1 border-2 border-gray-100 bg-white rounded-full relative cursor-pointer hover:border-gray-200 mr-3 mb-2 bg-gray-50`}
                    >
                      <div className="h-6 w-6 rounded-full overflow-hidden">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                          />
                        </svg>
                      </div>
                    </Popover.Button>

                    <Transition
                      as={React.Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel className="absolute z-10 right-0 mt-3 px-2 w-screen max-w-xs sm:px-0">
                        <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                          <div className="relative grid gap-1 bg-white p-2">
                            {platformsNotShown.map(p => (
                              <Link
                                to={`/topics/${topic.slug}/platform/${p.slug}/`}
                                key={p.slug}
                                disabled={p.count === 0}
                                className={`p-1 flex items-start cursor-pointer rounded-lg hover:bg-gray-50 transition ease-in-out duration-150`}
                              >
                                {/*<item.icon className="flex-shrink-0 h-6 w-6 text-rose-600" aria-hidden="true" />*/}
                                <div className="ml-0">
                                  <div className="text-base font-medium text-gray-900 flex">
                                    <div className="opacity-50 bold mr-1 w-8 text-center">
                                      {p.count}
                                    </div>
                                    <div>{p.name}</div>
                                  </div>
                                </div>
                              </Link>
                            ))}
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </>
                )}
              </Popover>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TopicPlatformIcons
